import { ENTITLEMENT_ACTIVITYNAMES } from "./common.constants";

// APIGEE_URLS
export const APIGEE_TOKEN_URL: any = {
    EUI_GET_CODE_REDIRECT_URL: {
        path: 'oauth2/v1/auth?client_id={{client}}&scope=TMO_ID_profile openid role extended_lines' // or scope=openid (JWT) or TMO_ID_profile
            + '&redirect_uri={{host}}&access_type=online&response_type=code&IDPType=iam',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'EUI_REDIRECTION'
    },
    IAM_TOKEN: {
        path: '/nodehap/tms/v3/usertoken',
        // path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/usertoken.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'IAM_TOKEN_CODE',
        flowType: 'IAM_FLOW',
        RedFlag: true,
    },
    ENTITLEMENTS_FETCH_ACTIVITIESID_IAM: {
        path: '/nodehap/auth/get-activities-iam/roles',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_IAM_ACTIVITY',
        flowType: 'IAM_FLOW',
        RedFlag: true,
        activities: [
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH)
        ]
    },
    APIGEE_ORG_USER_ACTIVITIES: {
        path: '/nodehap/auth/getOrgUser',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_USER_AND_ACTIVITIES',
        flowType: 'IAM_FLOW',
        RedFlag: true,
        queryparam: { userId: '?user-id=' },
        activities: [
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH)
        ]
    },
    APIGEE_BAN_ADDRESS_DETAILS: {
        path: '/nodehap/manage-lines/get-ban-billing-address',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'BAN_BILLING_ADDRESS_DETAILS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.ACCOUNT_DETAIL
        ]
    },
    APIGEE_BAN_ADDRESS_UPDATE: {
        path: '/nodehap/manage-lines/update-billing-address',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'BAN_BILLING_ADDRESS_UPDATE',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.DEFAULT_ADDRESS
        ]
    },
    APIGEE_TRANSACTION_HISTORY_DETAILS: {
        path: '/nodehap/transactions/getTransactionAccountOrders',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'GET_TRANSACTION_HISTORY_DETAILS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY
        ]
    },
    APIGEE_RESET_ENGAGEMENT: {
        path: '/nodehap/transactions/reset-engagement',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'RESET_TRANSANSACTION_HISTORY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY
        ]
    },
    APIGEE_DELIQUENCY_CHECK: {
        path: '/nodehap/home/status',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'DELIQUENCY_BAN_STATUS',
        activities: [
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH)
        ]
    },
    APIGEE_SUBSCRIBER_LINE_DETAILS_TEA_API: {
        path: '/nodehap/manage-lines/billing-accounts/subscriber-line-details',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'TEA_SUBSCRIBER_LINEDETAIL_API_CALL',
        apiName: 'SUBSCRIBER_LINE_DETAILS_TEA_V2',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION_SUBMIT
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH)
        ]
    },
    LINE_DETAILS_TEA_API: {
        path: '/nodehap/manage-lines/billing-accounts/line-details',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'TEA_SUBSCRIBER_LINEDETAIL_API_CALL',
        apiName: 'LINE_DETAILS_TEA_V4',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS
        ]
    },
    APIGEE_TRANSACTION_HISTORY: {
        path: '/nodehap/transactions/account-orders-history',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'GET_TRANSACTION_HISTORY',
        queryparam: {
            orderType: '?order-type=', pageSize: '&page-size=', dateRangeLimit: '&date-range-limit=',
            pageNumber: '&page=', mobileNumber: '&mobile-numbers=', billingAccounts: '&billing-accounts=', submittedBy: '&submitted-by=',
            noCache: '&noCache='
        },
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY
        ]
    },
    APIGEE_PAYMENT_DETAILS: {
        path: '/nodehap/transactions/autopay',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'GET_PAYMENT_DETAILS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.AUTOPAY_ENROLLMENT
        ]
    },
    SPLUNK_LOG: {
        path: '/nodehap/log/log-in-splunk',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'SPLUNK_COLLECTOR_CALL'

    },
    APIGEE_SUSPEND_REASONS: {
        path: '/nodehap/manage-lines/service-suspension-reasons',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'SUSPEND_FLOW',
        queryparam: '&noCache=',
        apiName: 'GET_SUSPEND_REASONS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.SUSPEND_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.SUSPEND_BULK
        ]
    },
    APIGEE_SIM_CHANGE_REASONS: {
        path: '/nodehap/manage-lines/sim-change-reasons',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'SIM_CHANGE_FLOW',
        queryparam: '&noCache=',
        apiName: 'GET_SIM_CHANGE_REASONS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_BULK
        ]
    },
    APIGEE_SUSPEND_APPROVAL_TYPES: {
        path: '/nodehap/manage-lines/service-suspension-approval-types',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'SUSPEND_FLOW',
        queryparam: { reasonCode: '?reason-code=' },
        apiName: 'GET_SUSPENSION_APPROVAL_TYPES',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.SUSPEND_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.SUSPEND_BULK,
            ENTITLEMENT_ACTIVITYNAMES.RESTORE_SINGLE
        ]
    },
    APIGEE_SUSPENSION_ELIGIBILITY: {
        path: '/nodehap/manage-lines/service-suspension-eligibility',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'SUSPEND_FLOW',
        queryparam: '&noCache=',
        apiName: 'GET_SUSPENSION_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.SUSPEND_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.SUSPEND_BULK
        ]
    },
    APIGEE_SIM_CHANGE_ELIGIBILITY: {
        path: '/nodehap/manage-lines/sim-change-eligibility',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'SIM_CHANGE_FLOW',
        apiName: 'GET_SIM_CHANGE_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_BULK
        ]
    },
    APIGEE_SERVICE_SUSPENSION: {
        path: '/nodehap/manage-lines/service-suspension',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'SUSPEND_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_SERVICE_SUSPENSION',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.SUSPEND_SINGLE
        ]
    },
    APIGEE_PORTIN_PST_DATE: {
        path: '/nodehap/home/getPortIndate',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'GET_PST_DATE',
        queryparam: '&noCache=',
        apiName: 'GET_PST_DATE',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICES,
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH)
        ]
    },
    APIGEE_AFFILIATION_LOOKUP_REF_INFO: {
        path: '/nodehap/affiliation-verification/lookup-affiliation-reference-info',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'AFFILIATION_FLOW',
        queryparam: '&noCache=',
        apiName: 'GET_AFFILIATION_REFERENCE_INFO',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION_SUBMIT
        ]
    },
    APIGEE_AFFILIATION_LOOKUP_INFO: {
        path: '/nodehap/affiliation-verification/lookup-affiliation-info',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'AFFILIATION_FLOW',
        queryparam: '&noCache=',
        apiName: 'GET_AFFILIATION_INFO',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION_SUBMIT
        ]
    },
    APIGEE_AFFILIATION_DOB_ENCRYPTION: {
        path: '/nodehap/affiliation-verification/encrypt-field',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'AFFILIATION_FLOW',
        queryparam: '&noCache=',
        apiName: 'AFFILIATION_DOB_ENCRYPTION',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION_SUBMIT
        ]
    },
    APIGEE_VERIFY_AFFILIATION: {
        path: '/nodehap/affiliation-verification/verify-affiliation',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'AFFILIATION_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_VERIFY_AFFILIATION',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION_SUBMIT
        ]
    },
    APIGEE_AFFILIATION_STATUS: {
        path: '/nodehap/affiliation-verification/verify-affiliation-status',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'AFFILIATION_FLOW',
        queryparam: '&noCache=',
        apiName: 'GET_VERIFY_AFFILIATION_STATUS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION_SUBMIT
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH)
        ]
    },
    APIGEE_ORGANIZATION_SEARCH: {
        path: '/nodehap/affiliation-verification/organizationSearch',
        canCache: false,
        isMocked: false,
        RedFlag: false,
        apiName: 'Organization_Name_Search_API',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION_SUBMIT
        ]
    },
    APIGEE_VERIFY_AFFILIATION_DOCUMENTS: {
        path: '/nodehap/affiliation-verification/verify-documents',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'AFFILIATION_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_AFFILIATION_DOCUMENTS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION_SUBMIT
        ]
    },
    APIGEE_CANCEL_SUBSCRIBER_ELIGIBILITY: {
        path: '/nodehap/cancel-subscriber/service-cancellation-eligibility',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'CANCEL_SUBSCRIBER',
        queryparam: '&noCache=',
        apiName: 'CANCEL_SUBSCRIBER_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CANCEL_SERVICE,
            ENTITLEMENT_ACTIVITYNAMES.CANCEL_SERVICE_BULK
        ]
    },
    APIGEE_SUBMIT_CANCEL_SUBSCRIBER: {
        path: '/nodehap/cancel-subscriber/cancel-subscriber',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'CANCEL_SUBSCRIBER',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_CANCEL_SUBSCRIBER',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CANCEL_SERVICE
        ]
    },
    APIGEE_SIM_CHANGE: {
        path: '/nodehap/manage-lines/service/sim-change',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'SIM_CHANGE_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_CHANGE_SIM_TRANSACTION',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_SINGLE
        ]
    },
    APIGEE_BULK_PROCESSOR: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_BULK_PROCESSOR',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_BULK,
            ENTITLEMENT_ACTIVITYNAMES.SUSPEND_BULK,
            ENTITLEMENT_ACTIVITYNAMES.RESTORE_BULK,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_BULK,
            ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER_BULK,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_BULK,
            ENTITLEMENT_ACTIVITYNAMES.CANCEL_SERVICE_BULK,
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_BULK,
            ENTITLEMENT_ACTIVITYNAMES.STRATEGIC_PORT_IN_BULK,
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_PORT_OUT_PROTECTION_BULK
        ]
    },
    APIGEE_BULK_SUSPEND: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'SUSPEND_BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_SUSPEND_BULK_PROCESSOR'
    },
    APIGEE_BULK_CANCEL_SUBSCRIBER: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'CANCEL_SUBSCRIBER_BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_CANCEL_SUBSCRIBER_BULK_PROCESSOR'
    },
    APIGEE_BULK_CHANGE_SERVICE: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'CHANGE_SERVICE_BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_CHANGE_SERVICE_BULK_PROCESSOR'
    },
    APIGEE_SIM_SWAP_BULK_PROCESSOR: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'SIM_SWAP_BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_SIM_SWAP_BULK_PROCESSOR'
    },
    APIGEE_BULK_UPLOAD: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_BULK_PROCESSOR'
    },
    APIGEE_NUMBER_CHANGE_REASON: {
        path: '/nodehap/manage-lines/mobile-number-change-reasons',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'MOBILE_NUMBER_CHANGE_FLOW',
        apiName: 'GET_CHANGE_NUMBER_REASONS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_BULK
        ]
    },
    APIGEE_NUMBER_CHANGE_REQUEST: {
        path: '/nodehap/manage-lines/mobile-number-change',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'MOBILE_NUMBER_CHANGE_FLOW',
        apiName: 'SUBMIT_CHANGE_NUMBER_REQUEST',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE
        ]
    },
    APIGEE_NUMBER_CHANGE_ELIGIBILITY: {
        path: '/nodehap/manage-lines/mobile-number-change-eligibility',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'MOBILE_NUMBER_CHANGE_FLOW',
        apiName: 'GET_CHANGE_NUMBER_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_BULK
        ]
    },
    APIGEE_NPA_NXX_LOOKUP: {
        path: '/nodehap/manage-lines/npa-nxx-lookup',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        queryparam: {
            area_code: '?npa=',
            market_code: '?market-code=',
            zip_code: '?zip-code=',
        },
        apiName: 'GET_NPA_NXX_LOOKUP',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_BULK
        ]
    },
    APIGEE_SUBSCRIBER_STATUS: {
        path: '/nodehap/manage-lines/subscriber-status',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        queryparam: {
            org: '?org=',
        },
        apiName: 'GET_SUBSCRIBER_RESTORE_STATUS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.RESTORE_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.RESTORE_BULK
        ]
    },
    APIGEE_RESTORATION_ELIGIBILITY: {
        path: '/nodehap/manage-lines/service-restoration-eligibility',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'RESTORE_FLOW',
        queryparam: '&noCache=',
        apiName: 'GET_RESTORE_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.RESTORE_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.RESTORE_BULK
        ]
    },
    APIGEE_SERVICE_RESTORE: {
        path: '/nodehap/manage-lines/service-restoration',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'RESTORE_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_RESTORE_REQUEST',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.RESTORE_SINGLE
        ]
    },
    APIGEE_BULK_SERVICE_RESTORE: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'RESTORE_SERVICE_BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_RESTORE_BULK_PROCESSOR'
    },
    APIGEE_CHANGE_NUMBER_BULK_PROCESSOR: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'CHANGE_NUMBER_BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_CHANGE_NUMBER_BULK_PROCESSOR'
    },
    APIGEE_LINE_IDENTIFIER_BULK_PROCESSOR: {
        path: '/nodehap/manage-lines/bulk-processor',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'LINE_IDENTIFIER_BULK_PROCESS_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_LINE_IDENTIFIER_BULK_PROCESSOR'
    },
    OKTA_ISSUER: {
        path: '/oauth2/{{okta_issuercode}}/v1/authorize?client_id={{okta_clientid}}&scope=openid'
            + '&redirect_uri={{okta_redirecturi}}&response_type=code&state=state-296bc9a0-a2a2-4a57-be1a-d0e2fd9bb602',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'OKTA_ISSUER',

    },
    OKTA_TOKEN: {
        // path: '/oauth2/{{okta_issuercode}}/v1/token',
        path: '/nodehap/auth/authorizeUserOkta',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'GET_OKTA_TOKEN'
    },
    OKTA_USERINFO: {
        path: '/oauth2/{{okta_issuercode}}/v1/userinfo',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'OKTA_USER_INFO'
    },
    OKTA_LOGOUT: {
        path: '/oauth2/{okta_issuercode}/v1/logout/?id_token_hint={id_token}&post_logout_redirect_uri={post_logout_redirect_uri}',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'OKTA_LOGOUT'
    },
    APIGEE_TRANSFER_NUMBER_REQUEST: {
        path: '/nodehap/manage-lines/port-in-change',
        canCache: false,
        isMocked: false,
        queryparam: '',
        submitCall: true,
        RedFlag: true,
        flowType: 'PORT_IN_FLOW',
        apiName: 'SUBMIT_TRANSFER_NUMBER_REQUEST',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.PORT_IN
        ]
    },
    APIGEE_TRANSFER_NUMBER_BULK_PROCESSOR: {
        path: '/nodehap/manage-lines/bulk-processor',
        // path: './assets/content-and-assets/rest-apis/transfer-number-request-bulk.json',
        canCache: false,
        isMocked: false,
        queryparam: '',
        submitCall: true,
        RedFlag: true,
        flowType: 'TRANSFER_NUMBER_BULK_PROCESS_FLOW',
        apiName: 'SUBMIT_TRANSFER_NUMBER_BULK_PROCESSOR'
    },
    APIGEE_TRANSFER_NUMBER_ELIGIBITY_REQUEST: {
        path: '/nodehap/manage-lines/port-in-eligibility',
        // path: './assets/content-and-assets/rest-apis/transfer-number-eligibility-request.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'TRANSFER_NUMBER_PORT_IN_FLOW',
        queryparam: '',
        apiName: 'GET_TRANSFER_NUMBER_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.PORT_IN
        ]
    },
    ENTITLEMENTS_FETCH_ACTIVITIESID_BYROLES_OKTA: {
        path: '/nodehap/auth/get-activities',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_ACTIVITIES_OKTA_USER',
        activities: [
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH)
        ]
    },
    ENTITLEMENTS_FETCH_CONFIGURATIONS_AM_EXP_NEW: {
        path: '/nodehap/home/fetchConfigurations',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'FETCH_CONFIGURATIONS',
        activities: [
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH)
        ]
    },
    APIGEE_LINE_IDENTIFIER_CHANGE: {
        path: '/nodehap/manage-lines/put-user-identifier',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'SUBMIT_LINE_IDENTIFIER_REQUEST',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER
        ]
    },
    APIGEE_GET_BAN_LIST_TEAAPI: {
        // path: '/nodehap/b2b-experience/v2/b2b-billing-accounts/orgs/{{orgID}}/users/{{user}}/billing-accounts',
        path: '/nodehap/home/get-billing-accounts',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        queryparam: {
            productType: '?product-type=',
            msisdnFilter: '&msisdn-filter=', userDetails: '&user-details=',
            groupIdParams: '&params=[group-id='
        },
        apiName: 'GET_BILLING_ACCOUNTS_NODE_LAYER',
        activities: [
            // global Nav (BAN.ACCOUNT_LOOKUP, BAN.ACCOUNT_LOOKUP_LH),
            ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY
        ]
    },
    GET_MISDIN_DETAILS: {
        path: '/nodehap/manage-lines/get-Msisdn-Details/lines',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS,
            ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY
        ]
    },

    APIGEE_EVALUATE_PROMOTION: {
        path: '/nodehap/cps/evaluate-promotions',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'CHANGESERVICE_FLOW',
        queryparam: '&noCache=',
        apiName: 'SUBMIT_EVALUATE_PROMOTION',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN
        ]
    },
    APIGEE_PLAN_CHANGE_EFFECTIVE_DATE: {
        path: '/nodehap/cps/plan-change-effective-date',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_PLAN_EFFECTIVE_DATE',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN
        ]
    },
    APIGEE_CHANGE_SERVICE: {
        path: '/nodehap/cps/get-change-services-details/services',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_SERVICES',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN,
            ENTITLEMENT_ACTIVITYNAMES
        ]
    },
    APIGEE_ORG_CATALOG_SERVICES: {
        path: '/nodehap/cps/catalog-aggregation',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_ORG_CATALOG_SERVICES',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_BULK
        ]
    },
    APIGEE_DOWNLOAD_TERMS: {
        path: '/nodehap/transactions/document-details',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_DOWNLOAD_TERMS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY
        ]
    },
    APIGEE_SUBSCRIBER_DETAILS: {
        path: '/nodehap/manage-lines/lines-of-service/subscribers',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'SUBSCRIBER_DETAILS_CHANGE_SERVICE',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES,
            ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS
        ]
    },
    APIGEE_SERVICE_AGREEMENT: {
        path: '/nodehap/cps/service-agreement',
        canCache: false,
        isMocked: false,

        submitCall: false,
        apiName: 'GET_SERVICE_AGREEMENT',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN
        ]
    },
    APIGEE_GET_UPGRADE_ELIGIBILITY: {
        path: '/nodehap/manage-lines/line-upgrade-eligibility-profiles',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_UPGRADE_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS
        ]
    },
    APIGEE_CHANGE_PLAN_POST: {
        path: '/nodehap/manage-lines/update-plan-change/plan-change',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        queryparam: '&noCache=',
        apiName: 'SUBMIT_CHANGE_SERVICE_PLAN',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN
        ]
    },
    APIGEE_GET_LOAN_HISTORY_NEW: {
        path: '/nodehap/cancel-subscriber/getLoanHistoriesNewQuery',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFalg: true,
        apiName: 'GET_LOAN_HISTORY_NEW_QUERY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CANCEL_SERVICE,
            ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS,
            ENTITLEMENT_ACTIVITYNAMES.MAKE_PAYMENTS
        ]
    },
    APIGEE_CHANGESERVICES_SUBMIT: {
        path: '/nodehap/cps/submit-plan-change',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'SUBMIT_CHANGE_SERVICE_PLAN'
    },
    APIGEE_PARTNER_SUBSCRIPTION_REDIRECTION: {
        path: '/nodehap/manage-lines/promotions/partner-subscriptions',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'PARTNER_SUBSCRIPTIONS'
    },
    APIGEE_ACCOUNT_MANAGER: {
        path: '/nodehap/manage-lines/user-list',
        // path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/account-manager-list.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_USERLIST_ACCOUNT_MANAGERS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BAN_USAGE
        ]
    },
    APIGEE_USAGE_UNBILLED_TOTAL: {
        path: '/nodehap/manage-lines/unbilled-total',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        queryparam: '&noCache=',
        apiName: 'GET_UNBILLED_TOTAL',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.USAGE_DETAILS
        ]
    },
    APIGEE_BILLING_INVOICE_SUMMARY: {
        path: '/nodehap/manage-lines/get-billing-summary',
        // path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/billing-invoice-summary.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        queryparam: { filter: '?filter=', financialAccountNumber: '&financialAccountNumber=', mobileNumber: '&mobileNumber=' },
        apiName: 'GET_BILLING_INVOICE_SUMMARY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BILL,
            ENTITLEMENT_ACTIVITYNAMES.USAGE_DETAILS,
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BAN_USAGE
        ]
    },
    APIGEE_BILLING_INVOICE_SUMMARY_SEQUENCE_NUMBER: {
        path: '/nodehap/manage-lines/get-billing-summary-by-sequence-number',
        // path: '/assets/tfb-acctmgmt/content-and-assets/rest-apis/billing-invoice-summary-sequence.json',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        queryparam: { filter: '?filter=', financialAccountNumber: '&financialAccountNumber=', mobileNumber: '&mobileNumber=' },
        apiName: 'GET_BILLING_INVOICE_SUMMARY_SEQUENCE_NUMBER',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BILL,
            ENTITLEMENT_ACTIVITYNAMES.USAGE_DETAILS,
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BAN_USAGE
        ]
    },
    APIGEE_BILLING_ACCOUNT_BILLS: {
        path: '/nodehap/manage-lines/get-billing-account-bills',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'GET_BILLING_ACCOUNT_BILLS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BILL,
            ENTITLEMENT_ACTIVITYNAMES.USAGE_DETAILS,
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BAN_USAGE
        ]
    },
    CHANGE_RATE_PLAN: {
        path: '/nodehap/cps/rate-plans',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN
        ]
    },
    SELECT_SERVICES: {
        path: '/nodehap/cps/get-change-services-details/services',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN,
            ENTITLEMENT_ACTIVITYNAMES
        ]
    },
    EMAIL_CONFIRMATION: {
        path: '/nodehap/cps/email-confirmation',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN
        ]
    },
    APIGEE_MANAGE_PLAN_SERVICES_API: {
        path: '/nodehap/manage-lines/get-account-level-plan-services',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'GET_PLAN_SERVICES_ACCOUNT_LEVEL',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BAN_USAGE
        ]
    },
    MICRO_SERVICE_LINES_DOWNLOAD: {
        path: '/nodehap/home/subscriber-line-details-multiple',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        flowType: 'BASIC_CALL',
        apiName: 'GET_SUBSCRIBER_LINE_DETAILS_NODE_LAYER'
    },
    APIGEE_ARRPOVAL_DASHBOARD_REQUESTS_API: {
        path: '/nodehap/approval-dashboard/approval-requests',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'GET_APPROVAL_REQUESTS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.APPROVAL_DASHBOARD,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN
        ]

    },
    ARRPOVAL_DASHBOARD_ACTION_API: {
        path: '/nodehap/approval-dashboard/actions',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'SUBMIT_APPROVAL_REQUESTS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.APPROVAL_DASHBOARD
        ]
    },
    ARRPOVAL_DASHBOARD_GET_ORG_CONFIG_API: {
        path: '/nodehap/approval-dashboard/get-org-config',
        canCache: false,
        isMocked: false,
        submitCall: true,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'GET_ORG_CONFIG',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.APPROVAL_DASHBOARD
        ]
    },
    APIGEE_FINANCIAL_ACCOUNT_USAGE_SUMMARY: {
        path: '/nodehap/manage-lines/get-ban-level-usage',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'GET_FINANCIAL_ACCOUNT_USAGE_SUMMARY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BAN_USAGE
        ]
    },
    APIGEE_AUTOPAY_ELIGIBILITY_API: {
        path: '/nodehap/manage-lines/get-autopay-eligibility',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'GET_AUTO_PAYMENT_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.AUTOPAY_ENROLLMENT
        ]
    },
    APIGEE_AUTOPAY_INFO_API: {
        path: '/nodehap/manage-lines/get-autopay-info',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'GET_AUTO_PAYMENT_INFO',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.AUTOPAY_ENROLLMENT
        ]
    },
    APIGEE_AUTOPAY_DISCOUNT_ELIGIBILITY_API: {
        path: '/nodehap/manage-lines/get-autopay-discount-eligibility',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'GET_AUTO_PAY_DISCOUNT_ELIGIBILITY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.AUTOPAY_ENROLLMENT
        ]
    },
    APIGEE_BAN_FRIENDLY: {
        path: '/nodehap/manage-lines/update-ban-friendly-name',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'SUBMIT_BAN_FRIENDLY_NAME',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.ACCOUNT_DETAIL,
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES
        ]
    },
    APGIEE_ACCOUNT_PASSWORD_CHANGE: {
        path: '/nodehap/manage-lines/update-password',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'SUBMIT_ACCOUNT_PASSWORD_CHANGE',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.UPDATE_BILLING_ACCOUNT_PASSWORD
        ]
    },
    PAPERLESS_BILLING: {
        path: '/nodehap/manage-lines/preferences/paperless-bill/query',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_PAPERLESS_BILLING_DETAILS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.BILL_DELIVERY,
            ENTITLEMENT_ACTIVITYNAMES.MAKE_PAYMENTS,
            ENTITLEMENT_ACTIVITYNAMES.OVERVIEW
        ]
    },
    BUSINESS_ADVISEMENT: {
        path: '/nodehap/manage-lines/business-advisement',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'GET_BUSINESS_ADVISEMENT',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.BILL_DELIVERY,
        ]
    },
    PAPERLESS_BILLING_ENROLL: {
        path: '/nodehap/manage-lines/edit-enroll-preferences/paperless-bill',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'PAPERLESS_BILLING_ENROLL'
    },
    PAPERLESS_BILLING_EDIT: {
        path: '/nodehap/manage-lines/edit-enroll-preferences/paperless-bill',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'PAPERLESS_BILLING_EDIT'
    },
    PAPERLESS_BILLING_UNENROLL: {
        path: '/nodehap/manage-lines/preferences/paperless-bill/unenroll',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'PAPERLESS_BILLING_UNENROLL',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.BILL_DELIVERY,
        ]
    },
    APGIEE_SUBMIT_RATEPLAN: {
        path: '/nodehap/cps/submit-plan-change',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'SUBMIT_RATEPLAN',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICES,
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN
        ]
    },
    APIGEE_LOCK_STATUS: {
        path: '/nodehap/manage-lines/get-lock-status/unlock-parameters',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'GET_LOCK_STATUS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS
        ]
    },
    // Need to implement once API is ready
    APIGEE_DEVICE_QUERY: {
        path: '/nodehap/manage-lines/getDeviceQuery',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'DEVICE_QUERY'
    },
    SIM_SWAP_AUTH: {
        path: '/nodehap/auth/validate-simswap-authToken',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'SIM_SWAP_AUTH_VERIFY_NODE'
    },
    APIGEE_STACKABLE_PLAN: {
        path: '/nodehap/manage-lines/stackable-plan',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'STACKABLE_PLAN',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.MAKE_PAYMENTS,
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BILL,
            ENTITLEMENT_ACTIVITYNAMES.AUTOPAY_ENROLLMENT,
            ENTITLEMENT_ACTIVITYNAMES.BILL_DELIVERY,
            ENTITLEMENT_ACTIVITYNAMES.USAGE_DETAILS,
            ENTITLEMENT_ACTIVITYNAMES.VIEW_BAN_USAGE
        ]
    },
    APIGEE_POST_V4_SUBSCRIBERS: {
        path: '/nodehap/manage-lines/lines-of-service/subscribers',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'POST_V4_SUBSCRIBERS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES,
            ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS
        ]
    },
    ACCESS_POPTOKEN_AUTH: {
        path: '/nodehap/auth/getPopTokens',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'ACCESS_POPTOKEN_AUTH'
    },
    APIGEE_ARRPOVAL_DASHBOARD_VIEW_DETAILS_API: {
        path: '/nodehap/approval-dashboard/view-details',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'GET_APPROVAL_DETAILS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.APPROVAL_DASHBOARD,
        ]
    },
    APIGEE_USER_ACCOUNT_QUERY_API: {
        path: '/nodehap/home/getUser_QueryList',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        flowType: 'BASIC_CALL',
        apiName: 'GET_APPROVAL_DETAILS',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES,
        ]
    },
    APIGEE_IOT_PRODUCT_CONFIG: {
        path: '/nodehap/manage-lines/getProductConfiguration',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'IOT_PRODUCT_CONFIG'
    },
    APIGEE_BUSINESS_CUSTOMER_SUBSCRIPTION: {
        path: '/nodehap/manage-lines/get-subscriptions',
        canCache: false,
        isMocked: false,
        submitCall: false,
        apiName: 'BUSINESS_CUSTOMER_SUBSCRIPTION'
    },
    APIGEE_SUBMIT_CART: {
        path: '/nodehap/manage-lines/submitCart',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'Submit_Cart'
     },
     REMOVE_PACKAGE_FROM_CART: {
        path: '/nodehap/manage-lines/removePackageFromCart',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'REMOVE_PACKAGE_FROM_CART'
     },
    //Below APIGEE_CREATE_CART and APIGEE_VALIDATE_CART constant might get differ depending on implementation of Validate API
    //START
     APIGEE_CREATE_CART: {
        path: '/nodehap/manage-lines/createCart',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'Cart_API'
     },
    APIGEE_VALIDATE_CART: {
        path: '/nodehap/manage-lines/validateCart',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'Cart_Validate_API',
        queryparam: { cartID: "?cartID=" }
    },
    //END
    APIGEE_CAT_TOOL_LINK: {
        path: '/nodehap/manage-lines/billing-accounts/cat-tool-url',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: true,
        apiName: 'ML_PTT_CAT_TOOL_URL_API',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES,
        ]
    },
    APIGEE_PAIRING_STATUS: {
        path: '/nodehap/manage-pairing/check-pairing-status',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'MANAGE_PAIRING_STATUS_API',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_BULK
        ]
    },
    APIGEE_MANAGE_PAIRING_ELIGIBILITY: {
        path: '/nodehap/manage-pairing/check-pairing-eligibility',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'MANAGE_PAIRING_ELIGIBILTY_API',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_BULK
        ]
    },
    APIGEE_MANAGE_PAIRING_SUBMIT: {
        path: '/nodehap/manage-pairing/manage-line-pairing',
        canCache: false,
        isMocked: false,
        submitCall: false,
        RedFlag: false,
        apiName: 'MANAGE_PAIRING_SUBMIT_API',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_SINGLE,
            ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_BULK
        ]
    },
    APIGEE_DELINQUENCY_STATUS: {
        path: '/nodehap/manage-lines/delinquency-status',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'DELINQUENCY_STATUS'
    },
    APIGEE_STRATEGIC_PORT_IN_PK: {
        path: '/nodehap/manage-lines/strategic-port-in-pk',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'STRATEGIC_PORT_IN_PUBLIC_KEY',
        activities: [
            ENTITLEMENT_ACTIVITYNAMES.STRATEGIC_PORT_IN_BULK
        ]
    },
    BULK_LINE_DETAILS: {
        path: '/nodehap/manage-lines/bulk-line-details',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'BULK_LINE_DETAILS'
    },
    FETCH_USER_NOTIFY_CONTACT: {
        path: '/nodehap/manage-lines/fetch-notify-contact-details',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'FETCH_USER_NOTIFY_CONTACT'
    },
    REMOVE_USER_NOTIFY_CONTACT: {
        path: '/nodehap/manage-lines/remove-notify-contact-details',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'REMOVE_USER_NOTIFY_CONTACT'
    },
    UPDATE_USER_NOTIFY_CONTACT: {
        path: '/nodehap/manage-lines/update-notify-contact-details',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'UPDATE_USER_NOTIFY_CONTACT'
    },
    FETCH_BLOCK_STATUS: {
        path: '/nodehap/manage-lines/fetch-block-status',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'FETCH_BLOCK_STATUS'
    },
    MANAGE_BLOCK_STATUS: {
        path: '/nodehap/manage-lines/manage-block-status',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'MANAGE_BLOCK_STATUS'
    },
    MANAGE_TRANSACTION_STATUS: {
        path: '/nodehap/manage-lines/manage-transaction-status',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'MANAGE_TRANSACTION_STATUS'
    },
    GENERATE_PORT_OUT_PIN: {
        path: '/nodehap/manage-lines/tpop-generation',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'GENERATE_PORT_OUT_PIN'
    },
    GET_PORT_OUT_PIN: {
        path: '/nodehap/manage-lines/tpop-generation-line',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'GET_PORT_OUT_PIN'
    },
    PORT_OUT_PIN_CANCELLATION: {
        path: '/nodehap/manage-lines/tpop-cancellation',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'PORT_OUT_PIN_CANCELLATION'
    },
    BROADBAND_LABEL: {
        path: '/nodehap/manage-lines/fetch-broadband-label',
        canCache: false,
        isMocked: false,
        submitCall: true,
        apiName: 'BROADBAND_LABEL'
    }
};

export const CONTENT_PAGES_URL: any = {
    CONTENT_ACCOUNT_MANAGEMENT: {
        path: '/nodehap/auth/getContent',
        canCache: false,
        isMocked: false,
        submitCall: false,
        flowType: 'CONTENT_CALL',
        RedFlag: true,
        apiName: 'GET_CONTENT_AUTHORING_DATA'
    },
};


